import { useEffect } from "react";
/**
 * Do not allow scrolling when this banner is visible
 *
 * @param visible
 */

function useRestrictScrollWhenVisible(visible) {
  return useEffect(() => {
    const {
      dataset,
      style
    } = document.body; // Save first state

    if (dataset.rcbPreviousOverflow === undefined) {
      dataset.rcbPreviousOverflow = style.overflow;
    }

    style.overflow = visible ? "hidden" : dataset.rcbPreviousOverflow;
    document.body.parentElement.style.overflow = style.overflow;
  }, [visible]);
}

export { useRestrictScrollWhenVisible };